<template>
  <div id="site-wrapper"  :class="{'show-nav': showCart}">
    <div id="site-canvas">

      <div class="Product">
        <div class="Product-Image">
          <img  v-show="portrait == true" src="http://lorempixel.com/400/600/food/4" @click="portrait = !portrait">
          <img width="100%" v-show="portrait == false" src="http://lorempixel.com/600/400/food/4" @click="portrait = !portrait">
        </div>
        <div class="Product-Details">
          <h2>Lorem ipsum dolor sit amet, consectetur adipisicing elit. </h2>
          <div class="Price">
            <span class="Price--Rebated">${{ price }}</span>
            <span class="">${{ rebated_price }}</span>
          </div>
          <hr>
          <br>
          <div >
            <ul class="Details-Nav">
              <li class="Details-Nav-Item" @click="section = 'description'"
                :class="{'Details-Nav-Item--Active': section == 'description'}">Description</li>
              <li class="Details-Nav-Item" @click="section = 'specifications'"
                :class="{'Details-Nav-Item--Active': section == 'specifications'}">Specifications</li>
            </ul>
            <div v-show="section == 'specifications'">
              <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
              tempor incididunt ut labore et dolore magna aliqua.</p>
              <ul>
                <li>option 1</li>
                <li>option 2</li>
                <li>option 3</li>
              </ul>
            </div>
            <div v-show="section == 'description'">

            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
              tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,
              quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
              consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse
              cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non
            proident, sunt in culpa qui officia deserunt mollit anim id est laborum. <span v-show="!fulldescription" class="text-primary" @click="fulldescription = true">more...</span></p>

            <p v-show="fulldescription">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
              tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,
              quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
              consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse
              cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non
            proident, sunt in culpa qui officia deserunt mollit anim id est laborum. <span class="text-primary" @click="fulldescription = false">less...</span></p>

            </div>
          </div>
          <hr>
          <br>
          <div>
            <div>
              <span>Size:</span>
              <select  v-model="price">
                <option value="79.99" >SMALL - $79.99</option>
                <option value="99.99">MEDIUM - $99.99</option>
                <option value="109.99">LARGE - $109.99</option>
              </select>
            </div>
            <br>
            <span>Modifiers:</span>
            <div>
            <div class="form-check">
              &nbsp;<input class="form-check-input" type="checkbox" name=""> for gift
              <label class="form-check-label">
                Option 1
              </label>
            </div>
            <div class="form-check">
              &nbsp;<input class="form-check-input" type="checkbox" value="">
              <label class="form-check-label" for="defaultCheck1">
                Option 2
              </label>
            </div>
            <div class="form-check">
              &nbsp;<input class="form-check-input" type="checkbox" value="">
              <label class="form-check-label" for="defaultCheck2">
                Oprion 3
              </label>
            </div>
            </div>
            <br>
            <div>
              Qty:
              <select >
                <option v-for="n in 10">{{ n }}</option>
              </select>

              <button class="btn btn-default">ADD TO CART</button>
            <br>
            <br>
            <button class="btn btn-default" @click="showCart = true">CART (0 items)</button>


            </div>

          </div>
        </div>
      </div>

      <div id="site-menu">

        <button @click="showCart = false">X</button>
        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
        tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,
        quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
        consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse
        cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non
        proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
      </div>
    </div>


  </div>
</template>

<script>
  export default {
    data () {
      return {
        portrait: true,
        showCart: false,
        fulldescription: false,
        section: 'description',
        price: '79.99'
      };
    },

    computed: {
      rebated_price () {
        return this.price - 10;
      }
    }
  };
</script>

<style scoped>
/*  .Wrapper {
    position: relative;
    display: flex;
  }*/

  #site-wrapper {
    position: relative;
    overflow: hidden;
    width: 100%;
  }

  #site-canvas {
    width: 100%;
    height: 100%;
    position: relative;
    -webkit-transform: translateX(0);
    transform: translateX(0);
    -webkit-transition: .3s ease all;
    transition: .3s ease all;
  }

  #site-menu {
    width: 400px;
    height: 100%;
    position: absolute;
    top: 0;
    right: -400px;
    /*background: #f5f5f5;*/
    border-left: 1px solid red;
    padding: 15px;
  }

  #site-wrapper.show-nav #site-canvas {
    -webkit-transform: translateX(-400px);
    transform: translateX(-400px);
  }

  .Product {
      /*background: red;*/
    display: flex;
  }

/*  .Cart {

    width: 40%;
  }
*/

  .Add-Cart-Button {
    width: 100%;
  }

  .Details-Nav {
    margin: 0;
    padding: 0;
    display: flex;
    list-style: none;
  }

  .Details-Nav-Item {
    padding: 3px 0;
    margin-right: 15px;
    margin-bottom: 10px;
  }

  .Details-Nav-Item--Active {
    border-bottom: 2px #2196f3 solid;
  }



  .Product-Image, .Product-Details {
    padding: 10px;
  }

  .Product-Image {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    min-width: 55%;
    background: #f5f5f5;
  }

  h2, hr {
    margin: 0;
  }

  img {
    max-width: 100%;
  }

  .Price {
    padding: 5px;
    font-size: 2em;
    color: red;
    margin-bottom: 10px;
  }

  .Price--Rebated {
    color: gray;
    text-decoration: line-through;
  }

  .add-to-cart {
    display: flex;
  }

  @media screen and (max-width: 768px) {
    .Product {
      display: block;
    }

    img {
      max-height: 500px;
    }
  }
</style>



// WEBPACK FOOTER //
// product-details.vue?19488cd1